module.exports = __webpack_public_path__ + "img/microphone.a01b0600.jpg";